import { CheckIcon } from "@heroicons/react/24/outline";

const STEPS = [
  { id: "website", label: "Website", status: "done" },
  { id: "sign-in", label: "Sign in", status: "current" },
  { id: "audit", label: "Audit", status: "upcoming" },
] as const;

export default function AuditSignupSteps() {
  return (
    <ol className="flex items-center justify-center gap-2 sm:gap-3" aria-label="Audit setup progress">
      {STEPS.map((step, index) => (
        <li key={step.id} className="flex items-center gap-2 sm:gap-3">
          {index > 0 ? <span className="h-px w-4 bg-gray-300 sm:w-6" aria-hidden="true" /> : null}
          <span className="flex items-center gap-1.5">
            <span
              className={`flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold ${
                step.status === "done"
                  ? "bg-primary text-white"
                  : step.status === "current"
                    ? "bg-primary/10 text-primary ring-2 ring-primary/20"
                    : "bg-gray-100 text-gray-500"
              }`}
              aria-current={step.status === "current" ? "step" : undefined}
            >
              {step.status === "done" ? <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" /> : index + 1}
            </span>
            <span className={`text-sm font-medium ${step.status === "upcoming" ? "text-gray-500" : "text-gray-900"}`}>
              {step.label}
            </span>
          </span>
        </li>
      ))}
    </ol>
  );
}
